import React, { useContext } from 'react';
import { Badge } from 'antd';

import MissingToolMappingsContext from '@totem/components/salesOrders/missingToolMappings/MissingToolMappingsContext';
import MissingToolMappingsFilters from '@totem/components/salesOrders/missingToolMappings/MissingToolMappingsFilters';
import MissingToolMappingsTable from '@totem/components/salesOrders/missingToolMappings/MissingToolMappingsTable';

export const MissingToolMappingsExtra = () => {
  const { totalRecords } = useContext(MissingToolMappingsContext);
  return (
    <Badge count={totalRecords} overflowCount={9999} offset={[0, -7]}>
      Missing Tool Mappings&nbsp;&nbsp;
    </Badge>
  );
};

const MissingToolMappingsLayout = () => (
  <>
    <MissingToolMappingsFilters />
    <MissingToolMappingsTable />
  </>
);

export default MissingToolMappingsLayout;
